import React, { FC } from 'react';
import { useTranslation } from '@wix/fe-essentials-standalone';
import { Box, Text, Accordion, accordionItemBuilder } from '@wix/design-system';
import { ChevronDown, ChevronUp } from '@wix/wix-ui-icons-common';
import s from './AdditionalInfoMobile.module.scss';
import GoodToKnow from '../GoodToKnow';
import SingleUseLicense from '../SingleUseLicense';
import { useTemplateBi } from '@components/Hooks/useTemplateBi';

type AdditionalInfoMobileProps = {
  hasAdditionalPurchaseApps: boolean;
};
const AdditionalInfoMobile: FC<AdditionalInfoMobileProps> = ({
  hasAdditionalPurchaseApps,
}) => {
  const { t } = useTranslation();
  const { logBiClick } = useTemplateBi({ is_mobile: true });

  const renderAccordionItem = ({
    key,
    titleKey,
    children,
    clickType,
  }: {
    key: string;
    titleKey: string;
    children: React.ReactNode;
    clickType: string;
  }) =>
    accordionItemBuilder({
      onAnimationEnter: () => logBiClick({ clickType }),
      horizontalPadding: 'none',
      key,
      title: <Text size="small">{t(titleKey)}</Text>,
      buttonType: 'node',
      hideShadow: true,
      showLabel: 'always',
      collapseLabel: <ChevronUp />,
      expandLabel: <ChevronDown />,
      children,
    });

  return (
    <Box width="100%" className={s.parent}>
      <Accordion
        dataHook="single-use-license-cta"
        skin="neutral"
        hideShadow
        multiple={true}
        horizontalPadding="large"
        items={[
          renderAccordionItem({
            key: 'singleUseLicense',
            titleKey: 'marketplace.template-page.single-use-license-title',
            children: <SingleUseLicense textSize="small" isMobileView={true} />,
            clickType: 'Single use license',
          }),
          renderAccordionItem({
            key: 'goodToKnow',
            titleKey: 'marketplace.template-page.good-to-know-title',
            children: (
              <Box
                width="100%"
                gap="15px"
                direction="vertical"
                paddingTop="6px"
              >
                <GoodToKnow
                  textSize="small"
                  hasAdditionalPurchaseApps={hasAdditionalPurchaseApps}
                />
              </Box>
            ),
            clickType: 'Good to know',
          }),
        ]}
      />
    </Box>
  );
};

export default AdditionalInfoMobile;
